import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9a59200a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a59200a')) {
      api.createRecord('9a59200a', component.options)
    } else {
      api.reload('9a59200a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9a59200a", function () {
      api.rerender('9a59200a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/classificationManage/index.vue"
export default component.exports